export const API_KEY = 'AIzaSyAUJZTUhQN1_vwj0nlIJvKe4CAT9c3PH1E';

export const MAP_STYLES = [
  {
    featureType: 'water',
    elementType: 'all',
    stylers: [
      {
        color: '#a4dbde',
      },
      {
        visibility: 'on',
      },
    ],
  },
  {
    featureType: 'administrative',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#444444',
      },
    ],
  },
  {
    featureType: 'landscape',
    elementType: 'all',
    stylers: [
      {
        color: '#f2f2f2',
      },
    ],
  },
  {
    featureType: 'landscape.man_made',
    elementType: 'all',
    stylers: [
      {
        visibility: 'on',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'all',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi.attraction',
    elementType: 'all',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi.business',
    elementType: 'all',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'all',
    stylers: [
      {
        saturation: -100,
      },
      {
        lightness: 45,
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'geometry.fill',
    stylers: [
      {
        saturation: '0',
      },
      {
        visibility: 'on',
      },
      {
        color: '#fefefe',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels.text',
    stylers: [
      {
        color: '#303030',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#aca9a9',
      },
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels.text.stroke',
    stylers: [
      {
        weight: '0.64',
      },
      {
        color: '#393939',
      },
      {
        visibility: 'on',
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'all',
    stylers: [
      {
        visibility: 'on',
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#ff6e33',
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'labels.text.fill',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'labels.text.stroke',
    stylers: [
      {
        weight: '2.99',
      },
      {
        visibility: 'on',
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'transit',
    elementType: 'all',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'all',
    stylers: [
      {
        color: '#a4dbde',
      },
      {
        visibility: 'on',
      },
    ],
  },
];

export const MAP_MARKER_ICON = {
  path: 'M18.107 49.9999C17.6131 49.7649 17.1982 49.3899 16.9166 48.9149C12.3281 42.3399 7.70491 35.7899 3.14103 29.1949C1.40241 26.6649 0.350352 23.7149 0.0885709 20.6449C-0.681954 12.6449 3.59051 4.94991 10.8364 1.77491C17.8699 -1.3101 24.5132 -0.370095 30.4601 4.56491C34.0806 7.54491 36.3823 11.8649 36.8515 16.5649C37.4442 21.2399 36.2341 25.9699 33.473 29.7649C29.0326 36.0999 24.5873 42.4449 20.137 48.7999C19.8456 49.3199 19.406 49.7399 18.8775 49.9999H18.107ZM24.6515 18.8199C24.6663 15.3749 21.9152 12.5699 18.512 12.5549C15.1089 12.5399 12.3379 15.3249 12.3231 18.7699C12.3083 22.1849 15.0101 24.9749 18.3836 25.0349C21.8065 25.0749 24.612 22.3049 24.6515 18.8399C24.6515 18.8349 24.6515 18.8249 24.6515 18.8199Z',
  fillColor: '#282828',
  fillOpacity: 1,
  anchor: { x: 14, y: 50 },
  strokeWeight: 0,
  scale: 1,
};

// Use above marker icon, and update the fill colour.
export const MAP_MARKER_ACTIVE_ICON = {
  ...MAP_MARKER_ICON,
  fillColor: '#ff6e33',
};

// Use above marker icon, and update the fill colour.
export const MAP_MARKER_URL =
  'https://s3-ap-southeast-2.amazonaws.com/media.campaign.august.com.au/guidedogs/brand-rollout/gd-map-marker.png';
